// var paywall = require("./lib/paywall");
// setTimeout(() => paywall(12345678), 5000);

require("component-responsive-frame/child");
require("component-leaflet-map");


var zoom = document.getElementById("interactive").offsetWidth > 500 ? 9 : 8;



const dataJSON = require("./census.geo.json");
// var contents = fs.readFile("./data.csv");
// console.log(contents);

var commafy = s => (s * 1).toLocaleString().replace(/\.0+$/, "");

//get access to Leaflet and the map
var element = document.querySelector("leaflet-map");
var L = element.leaflet;
var map = element.map;

var ich = require("icanhaz");
var templateFile = require("./_popup.html");
ich.addTemplate("popup", templateFile);
var focused = false;

const colorBlocks = document.querySelectorAll('.color');
var allSpans = document.querySelector('#legendCon').getElementsByTagName('span');

// const dataJSON = require("./JustWACounties.geo.json");
// const dataCSV = "./data.csv";

// const fileContent = fs.readFileSync("./data.csv");
dataJSON.features.forEach(function(f) {
  ["Zips_TPPC", "Zips_WPC", "Zips_BPC", "Zips_APC", "Zips_HPC", "Zips_AIANPC", "Zips_NHOPIPC" ].forEach(function(prop) {
     f.properties[prop] = (f.properties[prop] === ".") ? "N/A" : parseFloat(f.properties[prop]);
     var percentSign = prop + "_sign";
     f.properties[percentSign] = (f.properties[prop] === "N/A") ? "N/A" : f.properties[prop] + "%";
  });

  ["Zips_TP2010", "Zips_TP2020", "Zips_B2010", "Zips_B2020", "Zips_W2010", "Zips_W2020", "Zips_A2010", "Zips_A2020", "Zips_NHOPI2010", "Zips_NHOPI2020", "Zips_AIAN2010", "Zips_AIAN2020", "Zips_H2010", "Zips_H2020" ].forEach(function(prop) {
     f.properties[prop] =  commafy(f.properties[prop])
  });
});


var arrayLegend = {
  Zips_WPC_array: [-40,-20,-1,1.1,20,40],
  Zips_BPC_array: [-40,-20,-1,1.1,20,40],
  Zips_APC_array: [-40,-20,-1,1.1,20,40],
  Zips_HPC_array: [-40,-20,-1,1.1,20,40],
  Zips_AIANPC_array: [-40,-20,-1,1.1,20,40],
  Zips_NHOPIPC_array: [-40,-20,-1,1.1,20,40],
  Zips_TPPC_array: [-40,-20,-1,1.1,20,40],
  total: "Zips_TPPC",
  white: "Zips_WPC",
  black: "Zips_BPC",
  asian: "Zips_APC",
  hispanic: "Zips_HPC",
  aian: "Zips_AIANPC",
  nhopi: "Zips_NHOPIPC"
};

var getColor = function(d, array) {
  var value = d;
  // console.log(value);
  var thisArray = arrayLegend[array];
  let chosenColorArray = orangeArray;

  for (let h = 0; h < colorBlocks.length; h++) {
    colorBlocks[h].style.backgroundColor = chosenColorArray[h];
  }


  // if (typeof value == "string") {
  //   value = Number(value.replace(/,/, ""));
  // }
  if (value != "N/A") {
    return value >= thisArray[6] ? chosenColorArray[7] :
           value >= thisArray[5] ? chosenColorArray[6] :
           value >= thisArray[4] ? chosenColorArray[5] :
           value >= thisArray[3] ? chosenColorArray[4] :
           value >= thisArray[2] ? chosenColorArray[3] :
           value >= thisArray[1] ? chosenColorArray[2] :
           value >= thisArray[0]  ? chosenColorArray[1] :
           chosenColorArray[0] ;
  } else {
    return "#424648"
  }
};



// orangeArray = ['#FAE2C1', '#F4BD6E', '#ED8A52', '#E34D32', '#B22118', "#500601"];
orangeArray = ['#021838', '#295da5', '#93c4d2', '#ccc', '#F4BD6E', '#E34D32', '#B22118'];

function restyleLayer(propertyName) {

  geojson.eachLayer(function(featureInstanceLayer) {
      var propertyValue = featureInstanceLayer.feature.properties[propertyName];
      var colorArray = propertyName + "_array";

      // Your function that determines a fill color for a particular
      // property name and value.
      var myFillColor = getColor(propertyValue, colorArray);

      featureInstanceLayer.setStyle({
          fillColor: myFillColor,
          opacity: .25,
          color: '#000',
          fillOpacity: 0.6,
          weight: 1
      });
  });
}




var onEachFeature = function(feature, layer) {
  layer.bindPopup(ich.popup(feature.properties))
  layer.on({
    mouseover: function(e) {
      layer.setStyle({ weight: 2, fillOpacity: 1 });
    },
    mouseout: function(e) {
      if (focused && focused == layer) { return }
      layer.setStyle({ weight: 1, fillOpacity: 0.6 });
    }
  });
};


var geojson = L.geoJson(dataJSON, {
  onEachFeature: onEachFeature
}).addTo(map);



var filterMarkers = function(clickedID) {
  // document.querySelectorAll("#legendCon span").forEach(el => el.classList.add('hide'));
  // document.querySelectorAll(`#legendCon .${clickedID}`).forEach(el => el.classList.remove("hide"));
  document.querySelectorAll(".buttonCon .button").forEach(el => el.classList.remove("active"));
  document.getElementById(clickedID).classList.add("active");
  restyleLayer(arrayLegend[clickedID]);
}

document.querySelectorAll(".buttonCon .button").forEach(el => el.addEventListener('click', () => {
  filterMarkers(el.id);
}));


map.setView(new L.LatLng(47.488586894054535, -121.88314128621178), zoom);


//kick things off//
filterMarkers("total");
